export default __webpack_public_path__ + "static/media/a011-example9.476ebfb5.png";